"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import "./regular.css.js";
import "./semibold.css.js";
const BilholdFont = () => jsx(Fragment, {});
export {
  BilholdFont
};
